import React, { forwardRef } from 'react';

import { isLocalURL } from '$utilities/browser';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * 1. Generates default attributes based on the button type and link location.
 */
const Button = forwardRef((
    /**
     * @type {import('$types/components/partials/ui.d.ts').ButtonProps}
     */
    {
        as: ComponentTag = 'button',
        children,
        className = '',
        disabled,
        renderIcon,
        ...remainingProps
    },
    /** @type {React.ForwardedRef<(HTMLInputElement)>} */
    ref
) => {
    const buttonClasses = [];
    const defaultAttributes = {};

    /* [1] */
    switch (ComponentTag) {
        case 'a':
            if (remainingProps.href) {
                if (!isLocalURL(remainingProps.href)) {
                    defaultAttributes.rel = 'noopener noreferrer';
                    defaultAttributes.target = '_blank';
                }
            } else {
                if(!remainingProps.href) {
                    console.warn('Missing href attribute on <Button> component');
                }
            }
            break;

        case 'button':
            defaultAttributes.type = 'button';
            break;
    }

    buttonClasses.push(className);

    if (disabled) {
        buttonClasses.push('muted');
    } else {
        buttonClasses.push('cursor-pointer');
    }

    return (
        <ComponentTag
            className={buttonClasses.join(' ')}
            disabled={disabled}
            {...defaultAttributes}
            {...remainingProps}
            ref={ref}>
            {children}

            {renderIcon && (
                <span
                    aria-hidden={true}
                    className={`${children ? ' ml-5' : ''}`}>
                    {renderIcon}
                </span>
            )}
        </ComponentTag>
    );
});

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

Button.displayName = 'Button';

export default Button;
